import { useEffect, useRef } from "react";
import { subtitleCopy } from "../../iris/maker-language";
import type { TalkMessage } from "../IntakeTalk";

/** The whole conversation, every line in full, as a drawer over the screen. Focus moves in; Escape closes it. */
export function ReadBack({ open, messages, close }: { open: boolean; messages: TalkMessage[]; close: () => void }) {
  const back = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (open) back.current?.focus();
  }, [open]);
  if (!open) return null;
  const copy = subtitleCopy();
  return (
    <div
      className="subtitle-readback"
      role="dialog"
      aria-modal="true"
      aria-label={copy.readBack}
      onKeyDown={(event) => {
        if (event.key === "Escape") {
          event.stopPropagation();
          close();
        }
      }}
    >
      <ol>
        {messages.map((message, index) => (
          <li key={index} className={message.role}>
            <b>{message.role === "maker" ? copy.you : "Iris"}: </b>
            {message.text}
          </li>
        ))}
      </ol>
      <button ref={back} type="button" className="link" onClick={close}>{copy.close}</button>
    </div>
  );
}
